const notiPL = {
    TemplateCode: "",
    Label1: "",
    Value1: "",
    Label2: "",
    Value2: "",
    Label3: "",
    Value3: "",
    Label4: "",
    Value4: "",
    Label5: "",
    Value5: "",
    Label6: "",
    Value6: "",
    Label7: "",
    Value7: "",
    Label8: "",
    Value8: "",
    Label9: "",
    Value9: "",
    Label10: "",
    Value10: "",
    toMailAddress: "",
    ccMailAddress: "",
    bccMailAddress: "",
    Subject: "",
    Body: "",
    Signature: "",
    Attachment: [{
        contentType: '',
        filecontent: '',
        filename: '',
      }]
  };


  export {notiPL} 